import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { useMediaQuery } from '@uidotdev/usehooks';
import { XIcon } from 'lucide-react';
import * as React from 'react';
import { cn } from './utils/shadcn-utils';
function Dialog({ ...props }) {
    return _jsx(DialogPrimitive.Root, { "data-slot": "dialog", ...props });
}
function DialogTrigger({ ...props }) {
    return _jsx(DialogPrimitive.Trigger, { "data-slot": "dialog-trigger", ...props });
}
function DialogPortal({ ...props }) {
    return _jsx(DialogPrimitive.Portal, { "data-slot": "dialog-portal", ...props });
}
function DialogClose({ ...props }) {
    return _jsx(DialogPrimitive.Close, { "data-slot": "dialog-close", ...props });
}
const DialogOverlay = React.forwardRef(function DialogOverlay({ className, ...props }, ref) {
    return (_jsx(DialogPrimitive.Overlay, { ref: ref, "data-slot": "dialog-overlay", className: cn('data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50', className), ...props }));
});
const DialogContent = React.forwardRef(function DialogContent({ className, children, showCloseButton = true, ...props }, ref) {
    const isTerminalDevice = useMediaQuery('only screen and (max-width : 300px)');
    const dialogDeviceClasses = React.useMemo(() => {
        if (isTerminalDevice) {
            return 'max-w-screen max-h-screen w-full h-full rounded-none';
        }
        return '';
    }, [isTerminalDevice]);
    const handlePointerDownOutside = React.useCallback(event => {
        event.preventDefault();
    }, []);
    return (_jsxs(DialogPortal, { "data-slot": "dialog-portal", children: [_jsx(DialogOverlay, {}), _jsxs(DialogPrimitive.Content, { ref: ref, "data-slot": "dialog-content", className: cn('bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-full max-w-screen translate-x-[-50%] translate-y-[-50%] rounded-lg  p-6 shadow-lg duration-200', dialogDeviceClasses, className), onPointerDownOutside: handlePointerDownOutside, ...props, children: [children, showCloseButton && (_jsxs(DialogPrimitive.Close, { "data-slot": "dialog-close", className: "ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute top-4 right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-[var(--focus-ring-width)] focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", children: [_jsx(XIcon, {}), _jsx("span", { className: "sr-only", children: "Close" })] }))] })] }));
});
function DialogHeader({ className, ...props }) {
    return _jsx("div", { "data-slot": "dialog-header", className: cn('flex flex-col gap-2 text-center sm:text-left', className), ...props });
}
function DialogFooter({ className, ...props }) {
    return _jsx("div", { "data-slot": "dialog-footer", className: cn('flex flex-col-reverse gap-2 sm:flex-row mt-2 sm:justify-end', className), ...props });
}
function DialogTitle({ className, ...props }) {
    return _jsx(DialogPrimitive.Title, { "data-slot": "dialog-title", className: cn('text-lg leading-none font-semibold', className), ...props });
}
function DialogDescription({ className, ...props }) {
    return _jsx(DialogPrimitive.Description, { "data-slot": "dialog-description", className: cn('text-muted-foreground mb-4', className), ...props });
}
export { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogOverlay, DialogPortal, DialogTitle, DialogTrigger };
//# sourceMappingURL=Dialog.js.map